import { atom } from 'jotai'
import { tabs } from 'app/config/app'
import { FileCameraQuestion } from 'app/containers/QuestionerTemplate/types'

export type InfoImageQuestionnaire = {
  key: string
  itemId: string
  value: FileCameraQuestion
}

export const isModifiedAtom = atom<boolean>(false)
export const isShowPopupGlobalAtom = atom<boolean>(false)
export const subTabChoiceAtom = atom<string>(tabs.BASIC_SETTINGS)
export const pathChoiceAtom = atom<string>('')

const listImageQuestionnaireBaseAtom = atom<InfoImageQuestionnaire[]>([])

export const listImageQuestionnaireAtom = atom(
  get => get(listImageQuestionnaireBaseAtom),
  (get, set, newRecord: InfoImageQuestionnaire) => {
    const prev = get(listImageQuestionnaireBaseAtom)
    const compareFields = (
      a: InfoImageQuestionnaire,
      b: InfoImageQuestionnaire,
    ) => a.key === b.key && a.itemId === b.itemId

    const updatedRecords = prev.map(record =>
      compareFields(newRecord, record) ? newRecord : record,
    )
    const isNew = !prev.some(record => compareFields(newRecord, record))

    set(
      listImageQuestionnaireBaseAtom,
      isNew ? [...updatedRecords, newRecord] : updatedRecords,
    )
  },
)
